module.exports = __webpack_public_path__ + "img/t_2.00a435c6.png";